import { inject, Injectable, signal } from '@angular/core';
import { Bruger } from '../bruger.model';
import { BrugerDatasource } from '@features/brugere/bruger.datasource';
import { BrugerRolleApi } from '@features/brugere/bruger-roller/bruger-rolle.api';

interface BrugerRolleAddModel {
  action: 'add';
  rolleId: number;
  sendVelkomstmail?: boolean;
}

interface BrugerRolleRemoveModel {
  action: 'remove';
  id: number;
}

export type BrugerRolleChangeModel =
  | BrugerRolleAddModel
  | BrugerRolleRemoveModel;

@Injectable({
  providedIn: 'root',
})
export class BrugerDetailService {
  brugerDatasource = inject(BrugerDatasource);
  brugerRolleApi = inject(BrugerRolleApi);

  changes = signal<Record<number, BrugerRolleChangeModel>>({});

  async saveBrugerAndRoller(bruger: Bruger, kommentar: string) {
    const updatedBruger = await this.brugerDatasource.saveBrugerAndRoller(
      bruger,
      this.changes(),
      kommentar
    );

    //Update record in the datasource to show the new data in the list
    if (bruger.id) {
      this.brugerDatasource.updateData(updatedBruger);
    } else {
      this.brugerDatasource.insertData(updatedBruger);
    }

    return updatedBruger;
  }
}
